import { loader } from 'graphql.macro';
import { PSClientBuilder } from '../templates/_shared/apolloClientUtils';
import { getBrowseApiHeaders } from '../templates/search-page/SearchPageUtils/constants';
import { CountryCode } from 'src/generated/shopify-graphql';
import { ProductsFragment } from '../templates/product-listing-page/components/GetBRCollection.product-service.generated';
import { formatToUSD } from './currency';

const GetCollectionGQL = loader('../templates/product-listing-page/components/GetBRCollection.product-service.graphql');

/* Note: This component and the PLP share the same data source, but use different fetching logic.
          PLP data fetching updates need to be replicated here.
*/

export async function fetchBloomreachCollection(collectionHandle: string, limit: number, countryCode: CountryCode) {
  try {
    if (!collectionHandle) return null;

    const queryVariables = {
      handle: collectionHandle,
      limit: limit,
      countryCode: countryCode,
    };

    const { data, errors } = await PSClientBuilder.query({
      query: GetCollectionGQL,
      context: { headers: getBrowseApiHeaders() },
      variables: queryVariables,
    });

    if (errors) {
      console.error('Fetch BR GraphQL errors:', errors);
      return null;
    }

    const BRCollectionData = data?.productsByCollectionHandle;

    if (BRCollectionData?.__typename === 'ProductCategory') {
      const productWithIds: ProductWithId[] = BRCollectionData.products?.nodes?.map((product: ProductsFragment) => ({
        ...product,
        id: product.gid.split('/').pop()!,
      }));

      return JSON.stringify(mapBRCollectionForBuilder(productWithIds));
    } else {
      console.error('Unexpected data type from GraphQL getCollection');
      return null;
    }
  } catch (error) {
    console.error('Error fetching BR collection:', error);
    return null;
  }
}

function mapBRCollectionForBuilder(products: ProductWithId[]) {
  return {
    products: products.map((product) => {
      return {
        id: product.id,
        handle: product.handle,
        title: product.title,
        images: product.images.map((img) => ({
          src: img,
          alt: null,
        })),
        variants: product.variants.filter(Boolean).map((variant) => ({
          id: variant.gid,
          title: variant.title || '',
          compareAtPrice: variant.compareAtPrice?.amount,
          price: variant.price.amount,
          formattedCompareAtPrice: variant.compareAtPrice?.amount
            ? formatToUSD(Number(variant.compareAtPrice.amount))
            : null,
          formattedPrice: formatToUSD(variant.price.amount),
          availableForSale: variant.availableForSale,
          images: [
            {
              alt: '',
              src: variant.imageUrl,
            },
          ],
          currencyCode: variant.price.currencyCode,
        })),
        tags: product.tags,
        options: product.options,
      };
    }),
  };
}

type ProductWithId = ProductsFragment & {
  id: string;
};
